import { useTranslation } from "react-i18next";
import isEmpty from "lodash/isEmpty";
import isArray from "lodash/isArray";
import isObject from "lodash/isObject";
import Form from "../../../../../components/Form";
import { ReportSectionWrapper } from "../ReportSectionWrapper";
import { buildInvestigationFields } from "./reportInvestigationFields";

export { typeOptions } from "./reportInvestigationFields";

export const ReportInvestigation = ({ form, type, hasError, initialValues, data, basicDataSaved }) => {
  const { t } = useTranslation();
  const investigation = Form.useWatch("investigation", form) || {};
  let hasData = Object.values(investigation)?.some((item) => {
    if (isArray(item) || isObject(item)) {
      return !isEmpty(item);
    } else {
      return !!item;
    }
  });

  const fields = buildInvestigationFields({ hasData, data, t, form, type, initialValues });

  return (
    <ReportSectionWrapper
      form={form}
      type={type}
      hasError={hasError}
      data={data}
      basicDataSaved={basicDataSaved}
      fields={fields}
      sectionTitleKey="ior.new_report.section_investigation"
      sectionTooltipKey="ior.new_report.section_investigation_popover"
      successMessageKey="ior.new_report.notifications.investigation_saved"
      errorMessageKey="ior.new_report.notifications.investigation_not_saved"
    />
  );
};
